module.exports = __webpack_public_path__ + "static/media/AboutPage__Chika.2c9b49b8.png";